<template>
    <header class="container" id="header">
        <Logo :src="logoSrc" class="partner-logo" v-if="logoVisible"/>
    </header>
</template>

<script>
    import Logo from '../../../animod-shop/src/components/Logo';

    export default {
        name: 'Header',
        props: {
            logoSrc: String,
            meta: Object
        },
        components: {
            Logo
        },
        computed: {
            logoVisible() {
                return this.meta.logoUrl;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/_variables.scss";

    header#header {
        align-items: center;
        background-color: $header-background-color;
        border-bottom-left-radius: $header-border-radius;
        border-bottom-right-radius: $header-border-radius;
        color: $header-color;
        display: flex;
        flex-shrink: 0;
        height: $header-height;
        justify-content: center;
        position: relative;

        .logo {
            padding: 0 $header-logo-padding;
        }

        /deep/ .partner-logo {
            height: $partner-logo-height;
            width: $partner-logo-width;

            .logo-image {
                filter: $partner-logo-filter;
            }
        }

        .animod-logo {
            height: $animod-logo-height;
            width: $animod-logo-width;
            padding: 0 $grid-padding;
            position: relative;

            &::before {
                content: " ";
                height: 100%;
                position: absolute;
                color: rgba($header-color, 0.7);
                border-left: 1px solid;
                left: 0;
            }
        }

    }
</style>
